import { CITY_PRICES, ROUTES } from "./site";

// Páginas por tramo (SEO): se arman con los recorridos reales de ROUTES (stops = [parada, hora, ciudad]).
// Paradas del conurbano: cada una es su localidad (comparten la tarifa "Buenos Aires" del tarifario)
export const BA_STOPS = ["Virrey del Pino", "González Catán", "Laferrere", "Isidro Casanova", "San Justo", "Rotonda Crovara", "Crovara y General Paz", "Villa Celina", "Puente La Noria", "Liniers", "Terminal Dellepiane", "Retiro", "El Turista", "Pacheco"];
export const MAJOR = [...BA_STOPS, "Rosario", "Santa Fe", "Añatuya", "Quimilí", "La Banda", "Santiago del Estero", "Termas de Río Hondo", "Frías", "Tucumán", "Nueva Esperanza", "Monte Quemado"];
export const placeLabel = (c) => (BA_STOPS.includes(c) && c !== "Retiro" ? `${c} (Buenos Aires)` : c === "Retiro" ? "Retiro (CABA)" : c);

export const slugify = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// minutos desde la salida del recorrido, sumando un día cada vez que el horario "vuelve" atrás
const withOffsets = (stops) => {
  let day = 0;
  let prev = -1;
  return stops.map(([name, t, city]) => {
    const [h, m] = t.split(":").map(Number);
    const mins = h * 60 + m;
    if (mins < prev) day += 1;
    prev = mins;
    return { name, time: t, city, abs: day * 1440 + mins };
  });
};

const build = () => {
  const pages = {};
  ROUTES.forEach((route) => {
    const st = withOffsets(route.stops);
    st.forEach((a, i) => {
      if (!MAJOR.includes(a.city) || st.slice(0, i).some((x) => x.city === a.city)) return;
      st.slice(i + 1).forEach((b, k) => {
        const j = i + 1 + k;
        if (!MAJOR.includes(b.city) || b.city === a.city || (BA_STOPS.includes(a.city) && BA_STOPS.includes(b.city)) || st.slice(i + 1, j).some((x) => x.city === b.city)) return;
        const price = CITY_PRICES[`${a.city}|${b.city}`];
        if (!price) return;
        const slug = `${slugify(a.city)}-a-${slugify(b.city)}`;
        const lastAtOrigin = st.reduce((acc, x, n) => (x.city === a.city && n < j ? n : acc), i);
        pages[slug] = pages[slug] || { slug, origin: a.city, destination: b.city, semicama: price[0], cama: price[1], services: [] };
        pages[slug].services.push({
          routeId: route.id, routeName: route.name, days: route.days,
          boardings: st.slice(i, lastAtOrigin + 1).filter((x) => x.city === a.city),
          arrival: b, stops: st.slice(i, j + 1), minutes: b.abs - st[i].abs,
        });
      });
    });
  });
  return pages;
};

export const ROUTE_PAGES = build();
export const routePage = (slug) => ROUTE_PAGES[slug];
export const routePagesList = () => Object.values(ROUTE_PAGES);
export const routePath = (p) => `/pasajes/${p.slug}`;
export const duration = (mins) => (mins < 60 ? `${mins}\u00a0min` : `${Math.floor(mins / 60)}\u00a0h${mins % 60 ? ` ${String(mins % 60).padStart(2, "0")}\u00a0min` : ""}`);
